import { Reducer } from 'redux';
import { IPaymentPlanDataAction } from '../actions/paymentPlanAction';
import { PaymentPlanActionTypes } from '../constants/actionTypes';
import { IPaymentPlanData } from '../types/PaymentPlanTypes';

// Define the initial state
const initialState: IPaymentPlanState = {
  paymentPlansData: undefined,
  paymentPlansErrors: undefined,
};

export interface IPaymentPlanState {
  readonly paymentPlansData: IPaymentPlanData | undefined;
  readonly paymentPlansErrors: string[] | undefined
}

export const paymentPlanReducer: Reducer<IPaymentPlanState,
IPaymentPlanDataAction> = (
  state = initialState,
  action: IPaymentPlanDataAction,
) => {
  switch (action.type) {
    case PaymentPlanActionTypes.GET_PAYMENT_PLAN_DATA:
      return {
        ...state,
        paymentPlansData: action.paymentPlansData,
        paymentPlansErrors: undefined,
      };
    case PaymentPlanActionTypes.ERROR_GET_PAYMENT_PLAN_DATA:
      return {
        ...state,
        paymentPlansData: undefined,
        paymentPlansErrors: action.paymentPlansErrors,
      };
    default:
      return state;
  }
};
